import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const MailIcon = ({ viewBox, stroke, fill, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 24 24'}>
    <path
      d="M3.37537 6.97366C5.8458 8.83345 10.1806 12.1054 11.4547 13.1256C11.6257 13.2633 11.8092 13.3333 11.9996 13.3333C12.1897 13.3333 12.3728 13.2639 12.5434 13.1269C13.8186 12.1057 18.1534 8.83345 20.6239 6.97366C20.7777 6.8581 20.8012 6.65496 20.6766 6.51368C20.3888 6.18719 19.9596 6 19.4996 6H4.49963C4.03968 6 3.61046 6.18719 3.32263 6.51371C3.19811 6.65496 3.22156 6.8581 3.37537 6.97366Z"
      fill={fill}
    />
    <path
      d="M20.7825 7.9803C20.6496 7.92529 20.4932 7.94448 20.3826 8.02849C17.6429 10.093 14.1464 12.7393 13.0463 13.6205C12.4288 14.1159 11.5719 14.1159 10.953 13.6198C9.78038 12.6807 5.85384 9.71343 3.61741 8.02845C3.50607 7.94445 3.34935 7.92592 3.21751 7.98027C3.08497 8.03499 3 8.15283 3 8.28271V16.6659C3 17.4013 3.67271 17.9993 4.50001 17.9993H19.5C20.3273 17.9993 21 17.4013 21 16.6659V8.28271C21 8.15283 20.915 8.03467 20.7825 7.9803Z"
      fill={fill}
    />
  </BaseIcon>
);

export default MailIcon;
